// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class LoginRequests {
    /**
     * @param {string} login 
     * @param {string} password 
     * @param {boolean} isOsAuth 
     * @returns {Promise<VoidResponse>}
     */
    async Login(login, password, isOsAuth) {
        return await SmrClient.FetchJson({
            url: 'admin/Login',
            method: 'POST',
            body: { login, password, isOsAuth },
            bodyIsUrlParams: true
        });
    }

    /**
     * @returns {Promise<VoidResponse>}
     */
    async LogOut() {
        return await SmrClient.FetchJson({
            url: 'admin/LogOff',
            method: 'GET'
        });
    }
}

export default new LoginRequests;